var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 21V32.5C4.5 32.7761 4.72386 33 5 33H7.75C8.02614 33 8.25 32.7761 8.25 32.5V31.5M3.75 17.25H7.75C8.02614 17.25 8.25 17.4739 8.25 17.75V18.75M8.25 18.75H11.25M8.25 18.75V31.5M8.25 31.5H14.25L19.5 36.75C21.75 39 24.6562 35.9062 22.5 33.75M22.5 33.75C21.3 32.55 20.25 31.5 20.25 31.5M22.5 33.75C25.5 36.75 28.1719 32.6719 26.25 30.75M26.25 30.75L22.5 27M26.25 30.75C28.5 33 31.5 30 29.25 27.75M29.25 27.75C28.65 27.15 26.25 24.75 25.5 24M29.25 27.75C31.5 30 34.2891 26.7891 32.25 24.75C31.65 24.15 30.5 23 30 22.5",
    stroke: "#20376A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7499 20.25C32.4999 20.25 29.8499 20.25 29.2499 20.25C28.4999 20.25 26.2499 18 25.4999 18C23.9999 18 23.2499 18 22.4999 18C21.7499 18 21.7499 18 20.9999 18.75C20.2499 19.5 19.4999 20.25 18.7499 21C15.914 23.8359 11.9999 21 14.9999 18C17.9999 15 20.2499 12.75 20.9999 12C21.7499 11.25 21.5155 11.25 22.4999 11.25C23.2499 11.25 29.2499 11.25 29.9999 11.25C30.7499 11.25 30.7499 11.25 31.4999 12C32.0999 12.6 37.2499 17.75 39.7499 20.25M43.4999 17.25H40.2499C39.9738 17.25 39.7499 17.4739 39.7499 17.75V31.5M43.4999 21V32.5C43.4999 32.7761 43.276 33 42.9999 33H40.2499C39.9738 33 39.7499 32.7761 39.7499 32.5V31.5M33.7499 31.5H39.7499",
    stroke: "#BF9C41",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelling);
export default __webpack_public_path__ + "static/media/Selling.6d04663961633a0b26738c91a71e3b72.svg";
export { ForwardRef as ReactComponent };